// Full-site translations (English + Hindi). Testimonials stay verbatim in clinic.js.

const en = {
  langLabel: "हिंदी",
  nav: { services: "Services", about: "About", why: "Why Us", location: "Location", contact: "Contact" },
  common: {
    book: "Book Appointment",
    bookWhatsApp: "Book on WhatsApp",
    callNow: "Call Now",
    bookConsultation: "Book a consultation",
    getDirections: "Get Directions",
    viewOnGoogle: "View on Google",
    readGoogleReviews: "Read reviews on Google",
    followInstagram: "Follow on Instagram",
    followUs: "Follow us",
  },
  clinicShort: "Dr. Vinita Jain",
  hero: {
    badge1: "15+ Years Experience",
    badge2: "Periodontist & Implant Specialist",
    lines: ["Advanced technology.", "World-class", "dental care."],
    intro:
      "Patient-centered, gentle and painless dental care in Sector 16-17, Hisar — led by Dr. Vinita Jain (BDS, MDS), an MDS Periodontist & Implantologist. Dental implants, specialised gum care, teeth whitening, microscopic dentistry and esthetic smile designing for a healthy, confident smile.",
    emergency: "24×7 Emergency Care Available",
    yearsBadge: "Years in Hisar",
  },
  marquee: [
    "Patient-Centered Care",
    "Gentle Painless Treatment",
    "Dental Implants",
    "Specialized Gum Care",
    "Microscopic Dentistry",
    "Esthetic Smile Designing",
    "Teeth Whitening",
    "Sterile Hygiene",
    "Compassionate Care",
    "Healthy Confident Smile",
    "24×7 Emergency",
  ],
  about: {
    eyebrow: "01 / The Expert",
    heading: "Meet Dr. Vinita Jain, your gum & implant specialist in Hisar",
    p1: "Welcome to Kesari Dental Clinic, where healthy smiles and comfortable dental care come together. With over 15 years of experience, Dr. Vinita Jain is a dedicated MDS Periodontist & Implantologist — a true specialist in gum disease, pyorrhoea and dental implants, delivering personalized, high-quality treatments for patients of all ages.",
    p2: "Every visit is built on modern technology, sterile hygiene practices and a patient-first approach. From routine check-ups and preventive care to teeth whitening, dental implants, microscopic dentistry, esthetic smile designing and advanced restorative procedures — we focus on making every visit compassionate, gentle and painless.",
    p3: "Patients who arrive nervous or in pain leave calm — because Dr. Vinita takes the time to explain, and never rushes. Quality, safety and your comfort come first, always.",
    quote: "Your smile is our priority.",
    docCred: "BDS, MDS · Gum & Implant Specialist",
    stats: [
      { value: "15+", label: "Years Experience" },
      { value: "MDS", label: "Periodontist" },
      { value: "24×7", label: "Emergency Care" },
    ],
  },
  services: {
    eyebrow: "02 / Treatments",
    heading: "Complete dental care, with specialist expertise in gums & implants",
    subtitle: "From routine check-ups and preventive care to cosmetic dentistry, restorative treatments and advanced dental procedures — comprehensive, patient-centered solutions for every age.",
    groups: {
      signature: { label: "Signature / Specialist", tag: "Her expertise" },
      general: { label: "General & Cosmetic", tag: "Everyday care" },
      surgery: { label: "Gum & Oral Surgery", tag: "Specialised surgery" },
    },
    items: {
      pyorrhoea: { name: "Pyorrhoea (Gum Disease) Treatment", desc: "Flap surgery, bone grafting & connective tissue grafting for advanced gum disease." },
      implants: { name: "Dental Implants", desc: "Permanent, natural-looking tooth replacement placed with precision." },
      smile: { name: "Aesthetic Smile Designing", desc: "Complete smile makeovers tailored to your face and personality." },
      veneers: { name: "Dental Veneers", desc: "Thin, custom shells for a flawless, brighter front-tooth finish." },
      aligners: { name: "Dental Aligners & Wiring", desc: "Orthodontic treatment to straighten teeth discreetly." },
      microscopic: { name: "Microscopic Dentistry", desc: "Precision, minimally-invasive treatment using dental microscopes for sharper vision and better outcomes." },
      rct: { name: "Root Canal Treatment (RCT)", desc: "Save infected teeth with painless, sitting-based RCT." },
      fillings: { name: "Tooth-Colored Restorations", desc: "Composite fillings that blend naturally with your teeth." },
      bridges: { name: "Bridges (FPD) & Dentures (RPD)", desc: "Fixed and removable solutions to restore missing teeth." },
      crowning: { name: "Crowning / Capping", desc: "Durable caps that protect and strengthen damaged teeth." },
      whitening: { name: "Teeth Whitening", desc: "Safe, professional whitening for a confident smile." },
      scaling: { name: "Scaling", desc: "Deep cleaning to remove plaque, tartar and stains." },
      extractions: { name: "Extractions", desc: "Gentle, safe removal when a tooth cannot be saved." },
      gums: { name: "Bleeding & Infected Gums", desc: "Treatment for bleeding gums, infection & discolouration." },
      cyst: { name: "Gum Cyst Excision", desc: "Careful surgical removal of gum cysts and lesions." },
      fracture: { name: "Mandibular Fracture Management", desc: "Expert management of lower-jaw fractures." },
    },
  },
  why: {
    eyebrow: "03 / Why Choose Us",
    heading: "Why patients across Hisar trust Kesari Dental",
    imgTitle: "A clean, calm clinic",
    imgSub: "Fully sterilised, modern equipment for every patient.",
    items: [
      { title: "Patient-Centered Care", desc: "Personalized treatment plans, honest advice and unhurried consultations — because every smile is different." },
      { title: "MDS Periodontist & Implantologist", desc: "A true specialist in dental implants and gum care, not just a general dentist." },
      { title: "Gentle, Painless Treatment", desc: "Modern anaesthesia, microscopic precision and extra care for nervous and first-time patients." },
      { title: "Sterile Hygiene Practices", desc: "Strict sterilisation protocol and single-use consumables — quality and safety on every visit." },
      { title: "Microscopic Dentistry", desc: "Advanced dental microscopes for sharper vision, minimal cutting and more comfortable outcomes." },
      { title: "Compassionate 24×7 Care", desc: "15+ years of trusted care in Hisar, with emergency support any time — day or night." },
    ],
  },
  gallery: {
    eyebrow: "04 / Smile Gallery",
    heading: "Real smile transformations",
    subtitle: "Real patient cases from Kesari Dental Clinic — shared with patient consent. Drag the slider on any card to see the before and after.",
    before: "Before",
    after: "After",
    cases: [
      { title: "Fractured Tooth Restored", desc: "A broken front tooth with an exposed cavity, rebuilt with a natural-looking, tooth-coloured restoration." },
      { title: "Decayed Molar Restored", desc: "An old dark filling and decay replaced with a durable, tooth-coloured composite restoration." },
      { title: "Deep Cleaning & Scaling", desc: "Heavy tartar and stains along the gum line professionally removed for healthier gums and a cleaner smile." },
    ],
  },
  testimonials: {
    eyebrow: "05 / Patient Stories",
    heading: "What our patients say",
    rating: "5.0 · Real patient reviews",
  },
  timings: {
    eyebrow: "Clinic Timings",
    heading: "Open six days a week",
    days: [
      { d: "Monday", h: "10:00 AM – 7:00 PM" },
      { d: "Tuesday", h: "10:00 AM – 7:00 PM" },
      { d: "Wednesday", h: "10:00 AM – 7:00 PM" },
      { d: "Thursday", h: "10:00 AM – 7:00 PM" },
      { d: "Friday", h: "10:00 AM – 7:00 PM" },
      { d: "Saturday", h: "10:00 AM – 7:00 PM" },
      { d: "Sunday", h: "Emergency only" },
    ],
    emgTitle: "24×7 Dental Emergency",
    emgBody: "Severe tooth pain, swelling, bleeding gums or a dental injury at night or on a Sunday? We're available round the clock on the same number — just call or WhatsApp us.",
    callEmg: "Call Emergency",
    waNow: "WhatsApp Now",
    emgMsg: "Hello Dr. Vinita's Kesari Dental Clinic, I have a dental emergency and need urgent help.",
  },
  location: {
    eyebrow: "06 / Find Us",
    heading: "Right in the heart of Sector 16-17, Hisar",
    addrTitle: "Our Address",
    address: "DSS 379, Sector 16-17, Hisar, Haryana, India",
    addrNote: "Easy to reach with parking nearby. Landmark: Main Market, Sector 16-17.",
  },
  faq: {
    eyebrow: "07 / Questions",
    heading: "Frequently asked questions",
    subtitle: "Still unsure about something? Message us on WhatsApp — Dr. Vinita's team is happy to help before you even step in.",
    items: [
      { q: "Where is Dr. Vinita's Kesari Dental Clinic located?", a: "We're at DSS 379, Sector 16-17, Hisar, Haryana — easy to reach and with parking nearby. You can use the \"Get Directions\" button on this page." },
      { q: "What are the clinic timings?", a: "We're open Monday to Saturday, 10:00 AM to 7:00 PM. For emergencies, we're available 24×7 — just call or WhatsApp us at 9729002444." },
      { q: "Do you handle dental emergencies at night or on Sundays?", a: "Yes. For urgent issues like severe tooth pain, swelling, bleeding, or injury, you can reach us anytime on 9729002444, even outside regular hours." },
      { q: "How do I book an appointment?", a: "The easiest way is to click any \"Book Appointment\" button on this page — it opens WhatsApp with your details ready to send. You can also call us directly." },
      { q: "Is Dr. Vinita a specialist?", a: "Yes. Dr. Vinita Jain is an MDS Periodontist & Implantologist (gum and dental implant specialist) with 15 years of experience, in addition to handling all general dental care." },
      { q: "Does the treatment hurt? I'm scared of the dentist.", a: "Most patients are surprised at how painless modern treatment is. We use advanced microscopic techniques and take extra care with nervous or first-time patients." },
      { q: "Do you treat gum problems like bleeding gums and pyorrhoea?", a: "Absolutely — this is our core specialty. We treat bleeding gums, gum infections, pyorrhoea, and offer advanced procedures like flap surgery, bone grafting, and gum treatment." },
      { q: "What should I do before my first visit?", a: "Nothing special — just bring any previous dental reports or X-rays if you have them. We'll examine you and explain your options clearly before starting any treatment." },
      { q: "Do you offer teeth whitening and smile makeovers?", a: "Yes, we offer teeth whitening, veneers, and complete esthetic smile designing to help you get a brighter, more confident smile." },
      { q: "Are the instruments sterilized and safe?", a: "Yes, we follow strict sterile hygiene practices with world-class instruments, so every patient is treated with fully sanitized equipment on every visit." },
      { q: "Do you treat patients of all ages, including children and seniors?", a: "Yes — we provide comprehensive, patient-centered dental care for every age, from a child's first check-up to gentle, painless treatment for elderly patients." },
      { q: "How much does a dental implant cost in Hisar?", a: "Dental implant cost depends on the implant system, bone condition and number of teeth being replaced. After a free first consultation and X-ray, Dr. Vinita will give you a clear, upfront estimate — no hidden charges. WhatsApp us on 9729002444 to check the current price." },
    ],
  },
  contact: {
    eyebrow: "08 / Book Now",
    heading: "Book your appointment",
    intro: "Fill in a few details and we'll open WhatsApp with your request ready to send. Prefer to talk? Call us directly — we're happy to help.",
    callLabel: "Call / WhatsApp",
    visitLabel: "Visit Us",
    name: "Name",
    namePh: "Your full name",
    phone: "Phone",
    phonePh: "Your mobile number",
    service: "Service needed",
    servicePh: "Select a treatment",
    date: "Preferred date",
    datePh: "Pick a date",
    time: "Preferred time",
    timePh: "Pick a time",
    message: "Message (optional)",
    messagePh: "Tell us briefly about your dental concern…",
    submit: "Send booking on WhatsApp",
    note: "This opens WhatsApp with your details prefilled — no data is stored.",
    validation: "Please add your name and phone number so we can confirm your slot.",
    opening: "Opening WhatsApp with your appointment details…",
  },
  footer: {
    tagline: "Patient-centered, gentle and painless dental care — dental implants, specialised gum care, teeth whitening, microscopic dentistry and esthetic smile designing for a healthy, confident smile.",
    quickLinks: "Quick Links",
    visitHours: "Visit / Hours",
    hoursLine: "Mon – Sat: 10:00 AM – 7:00 PM",
    emergencyLine: "Emergency: 24×7",
    rights: "All rights reserved.",
    seoLine: "Best Dentist in Hisar · Dental Implants · Gum Care · Smile Designing",
  },
};

const hi = {
  langLabel: "English",
  nav: { services: "सेवाएं", about: "परिचय", why: "क्यों चुनें", location: "स्थान", contact: "संपर्क" },
  common: {
    book: "अपॉइंटमेंट बुक करें",
    bookWhatsApp: "WhatsApp पर बुक करें",
    callNow: "अभी कॉल करें",
    bookConsultation: "परामर्श बुक करें",
    getDirections: "रास्ता देखें",
    viewOnGoogle: "Google पर देखें",
    readGoogleReviews: "Google पर समीक्षाएँ पढ़ें",
    followInstagram: "Instagram पर फ़ॉलो करें",
    followUs: "हमें फ़ॉलो करें",
  },
  clinicShort: "डॉ. विनीता जैन",
  hero: {
    badge1: "15+ वर्षों का अनुभव",
    badge2: "पेरियोडॉन्टिस्ट व इम्प्लांट विशेषज्ञ",
    lines: ["उन्नत तकनीक।", "विश्वस्तरीय", "डेंटल देखभाल।"],
    intro:
      "सेक्टर 16-17, हिसार में मरीज़-केंद्रित, सौम्य और दर्दरहित डेंटल केयर — डॉ. विनीता जैन (BDS, MDS), MDS पेरियोडॉन्टिस्ट व इम्प्लांटोलॉजिस्ट द्वारा। डेंटल इम्प्लांट, विशेष मसूड़ा देखभाल, दाँत सफ़ेद करना, माइक्रोस्कोपिक डेंटिस्ट्री और एस्थेटिक स्माइल डिज़ाइनिंग — एक स्वस्थ, आत्मविश्वासी मुस्कान के लिए।",
    emergency: "24×7 आपातकालीन सेवा उपलब्ध",
    yearsBadge: "वर्ष हिसार में",
  },
  marquee: [
    "मरीज़-केंद्रित देखभाल",
    "सौम्य दर्दरहित इलाज",
    "डेंटल इम्प्लांट",
    "विशेष मसूड़ा देखभाल",
    "माइक्रोस्कोपिक डेंटिस्ट्री",
    "एस्थेटिक स्माइल डिज़ाइनिंग",
    "दाँत सफ़ेद करना",
    "स्टेराइल हाइजीन",
    "करुणामय देखभाल",
    "स्वस्थ आत्मविश्वासी मुस्कान",
    "24×7 इमरजेंसी",
  ],
  about: {
    eyebrow: "01 / विशेषज्ञ",
    heading: "मिलिए डॉ. विनीता जैन से — हिसार की मसूड़ा व इम्प्लांट विशेषज्ञ",
    p1: "केसरी डेंटल क्लिनिक में आपका स्वागत है, जहाँ स्वस्थ मुस्कान और आरामदायक डेंटल केयर एक साथ मिलते हैं। 15+ वर्षों के अनुभव के साथ, डॉ. विनीता जैन एक समर्पित MDS पेरियोडॉन्टिस्ट व इम्प्लांटोलॉजिस्ट हैं — मसूड़ों की बीमारी, पायरिया और डेंटल इम्प्लांट में सच्ची विशेषज्ञ, हर उम्र के मरीज़ों के लिए व्यक्तिगत, उच्च-गुणवत्ता वाले इलाज।",
    p2: "हर विज़िट आधुनिक तकनीक, स्टेराइल हाइजीन प्रोटोकॉल और मरीज़-प्रथम दृष्टिकोण पर आधारित है। रूटीन चेक-अप और प्रिवेंटिव केयर से लेकर दाँत सफ़ेद करने, डेंटल इम्प्लांट, माइक्रोस्कोपिक डेंटिस्ट्री, एस्थेटिक स्माइल डिज़ाइनिंग और उन्नत रीस्टोरेटिव प्रक्रियाओं तक — हर विज़िट को करुणामय, सौम्य और दर्दरहित बनाना हमारा लक्ष्य है।",
    p3: "घबराए या दर्द में आए मरीज़ शांत होकर लौटते हैं — क्योंकि डॉ. विनीता समझाने में समय देती हैं, कभी जल्दबाज़ी नहीं करतीं। गुणवत्ता, सुरक्षा और आपका आराम — हमेशा पहले।",
    quote: "आपकी मुस्कान हमारी प्राथमिकता है।",
    docCred: "BDS, MDS · मसूड़ा व इम्प्लांट विशेषज्ञ",
    stats: [
      { value: "15+", label: "वर्षों का अनुभव" },
      { value: "MDS", label: "पेरियोडॉन्टिस्ट" },
      { value: "24×7", label: "इमरजेंसी सेवा" },
    ],
  },
  services: {
    eyebrow: "02 / इलाज",
    heading: "संपूर्ण डेंटल देखभाल, मसूड़ों व इम्प्लांट में विशेष विशेषज्ञता के साथ",
    subtitle: "रूटीन चेक-अप और प्रिवेंटिव केयर से लेकर कॉस्मेटिक डेंटिस्ट्री, रीस्टोरेटिव इलाज और उन्नत डेंटल प्रक्रियाओं तक — हर उम्र के लिए मरीज़-केंद्रित, संपूर्ण समाधान।",
    groups: {
      signature: { label: "सिग्नेचर / विशेषज्ञ", tag: "इनकी विशेषज्ञता" },
      general: { label: "जनरल व कॉस्मेटिक", tag: "रोज़मर्रा की देखभाल" },
      surgery: { label: "मसूड़ा व ओरल सर्जरी", tag: "विशेष सर्जरी" },
    },
    items: {
      pyorrhoea: { name: "पायरिया (मसूड़ा रोग) इलाज", desc: "गंभीर मसूड़ा रोग के लिए फ्लैप सर्जरी, बोन ग्राफ्टिंग व कनेक्टिव टिशू ग्राफ्टिंग।" },
      implants: { name: "डेंटल इम्प्लांट", desc: "सटीकता से लगाए गए स्थायी, प्राकृतिक दिखने वाले दाँत।" },
      smile: { name: "एस्थेटिक स्माइल डिज़ाइनिंग", desc: "आपके चेहरे व व्यक्तित्व के अनुरूप संपूर्ण स्माइल मेकओवर।" },
      veneers: { name: "डेंटल विनियर", desc: "आगे के दाँतों को बेदाग़, चमकदार रूप देने वाले पतले कस्टम शेल।" },
      aligners: { name: "डेंटल अलाइनर व वायरिंग", desc: "दाँतों को सहजता से सीधा करने का ऑर्थोडॉन्टिक इलाज।" },
      microscopic: { name: "माइक्रोस्कोपिक डेंटिस्ट्री", desc: "डेंटल माइक्रोस्कोप की सहायता से सटीक, कम-चीरफाड़ वाला इलाज — बेहतर दृष्टि, बेहतर परिणाम।" },
      rct: { name: "रूट कैनाल इलाज (RCT)", desc: "दर्दरहित, सिटिंग-आधारित RCT से संक्रमित दाँत बचाएं।" },
      fillings: { name: "टूथ-कलर्ड फिलिंग", desc: "आपके दाँतों में स्वाभाविक रूप से घुल-मिल जाने वाली कंपोज़िट फिलिंग।" },
      bridges: { name: "ब्रिज (FPD) व डेन्चर (RPD)", desc: "गायब दाँत बहाल करने के फिक्स्ड व हटाने योग्य समाधान।" },
      crowning: { name: "क्राउनिंग / कैपिंग", desc: "क्षतिग्रस्त दाँतों की रक्षा व मज़बूती के लिए टिकाऊ कैप।" },
      whitening: { name: "दाँत सफ़ेद करना", desc: "आत्मविश्वासी मुस्कान के लिए सुरक्षित, प्रोफेशनल व्हाइटनिंग।" },
      scaling: { name: "स्केलिंग", desc: "प्लाक, टार्टर और दाग़ हटाने की गहरी सफ़ाई।" },
      extractions: { name: "दाँत निकालना", desc: "जब दाँत बचाया न जा सके तो सौम्य, सुरक्षित निष्कासन।" },
      gums: { name: "मसूड़ों से खून व संक्रमण", desc: "मसूड़ों से खून आना, संक्रमण व रंग बदलने का इलाज।" },
      cyst: { name: "गम सिस्ट एक्सिज़न", desc: "मसूड़े की गाँठ व घाव का सावधानीपूर्वक सर्जिकल निष्कासन।" },
      fracture: { name: "मैंडिबुलर फ्रैक्चर प्रबंधन", desc: "निचले जबड़े के फ्रैक्चर का विशेषज्ञ प्रबंधन।" },
    },
  },
  why: {
    eyebrow: "03 / हमें क्यों चुनें",
    heading: "हिसार के मरीज़ केसरी डेंटल पर क्यों भरोसा करते हैं",
    imgTitle: "स्वच्छ, शांत क्लिनिक",
    imgSub: "हर मरीज़ के लिए पूरी तरह स्टेरलाइज़्ड, आधुनिक उपकरण।",
    items: [
      { title: "मरीज़-केंद्रित देखभाल", desc: "व्यक्तिगत इलाज योजना, ईमानदार सलाह और बिना जल्दबाज़ी के परामर्श — क्योंकि हर मुस्कान अलग है।" },
      { title: "MDS पेरियोडॉन्टिस्ट व इम्प्लांटोलॉजिस्ट", desc: "सिर्फ जनरल डेंटिस्ट नहीं, बल्कि सच्ची मसूड़ा व इम्प्लांट विशेषज्ञ।" },
      { title: "सौम्य, दर्दरहित इलाज", desc: "आधुनिक एनेस्थीज़िया, माइक्रोस्कोपिक सटीकता और घबराए व पहली बार आने वाले मरीज़ों की अतिरिक्त देखभाल।" },
      { title: "स्टेराइल हाइजीन प्रोटोकॉल", desc: "सख़्त स्टेरलाइज़ेशन और सिंगल-यूज़ उपकरण — हर विज़िट पर गुणवत्ता व सुरक्षा।" },
      { title: "माइक्रोस्कोपिक डेंटिस्ट्री", desc: "डेंटल माइक्रोस्कोप से बेहतर दृष्टि, कम चीरफाड़ और अधिक आरामदायक परिणाम।" },
      { title: "करुणामय 24×7 देखभाल", desc: "हिसार में 15+ वर्षों की भरोसेमंद देखभाल, किसी भी समय — दिन हो या रात — इमरजेंसी सहायता।" },
    ],
  },
  gallery: {
    eyebrow: "04 / स्माइल गैलरी",
    heading: "असली स्माइल ट्रांसफ़ॉर्मेशन",
    subtitle: "केसरी डेंटल क्लिनिक के असली मरीज़ केस — मरीज़ की सहमति से साझा किए गए। पहले और बाद का फ़र्क देखने के लिए किसी भी कार्ड पर स्लाइडर खींचें।",
    before: "पहले",
    after: "बाद में",
    cases: [
      { title: "टूटा दाँत बहाल", desc: "टूटे हुए आगे के दाँत को, जिसमें कैविटी दिख रही थी, प्राकृतिक दिखने वाले टूथ-कलर्ड रीस्टोरेशन से बहाल किया गया।" },
      { title: "क्षतिग्रस्त दाढ़ बहाल", desc: "पुरानी काली फिलिंग और कैविटी को नई, टिकाऊ, टूथ-कलर्ड कंपोज़िट फिलिंग से बदला गया।" },
      { title: "गहरी सफ़ाई व स्केलिंग", desc: "मसूड़ों की लाइन पर जमे भारी टार्टर व दाग़ को प्रोफेशनल तरीके से हटाया गया — स्वस्थ मसूड़े, साफ़ मुस्कान।" },
    ],
  },
  testimonials: {
    eyebrow: "05 / मरीज़ों की कहानियाँ",
    heading: "हमारे मरीज़ क्या कहते हैं",
    rating: "5.0 · असली मरीज़ों की समीक्षा",
  },
  timings: {
    eyebrow: "क्लिनिक समय",
    heading: "सप्ताह में छह दिन खुला",
    days: [
      { d: "सोमवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "मंगलवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "बुधवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "गुरुवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "शुक्रवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "शनिवार", h: "सुबह 10:00 – शाम 7:00" },
      { d: "रविवार", h: "केवल इमरजेंसी" },
    ],
    emgTitle: "24×7 डेंटल इमरजेंसी",
    emgBody: "रात में या रविवार को तेज़ दाँत दर्द, सूजन, मसूड़ों से खून या दाँत की चोट? हम इसी नंबर पर चौबीसों घंटे उपलब्ध हैं — बस कॉल या WhatsApp करें।",
    callEmg: "इमरजेंसी कॉल",
    waNow: "अभी WhatsApp करें",
    emgMsg: "नमस्ते डॉ. विनीता केसरी डेंटल क्लिनिक, मुझे डेंटल इमरजेंसी है और तुरंत मदद चाहिए।",
  },
  location: {
    eyebrow: "06 / हमें ढूँढें",
    heading: "सेक्टर 16-17, हिसार के बिल्कुल केंद्र में",
    addrTitle: "हमारा पता",
    address: "DSS 379, सेक्टर 16-17, हिसार, हरियाणा, भारत",
    addrNote: "पास में पार्किंग के साथ आसानी से पहुँचें। लैंडमार्क: मेन मार्केट, सेक्टर 16-17।",
  },
  faq: {
    eyebrow: "07 / सवाल",
    heading: "अक्सर पूछे जाने वाले सवाल",
    subtitle: "अब भी कोई संदेह है? हमें WhatsApp करें — आने से पहले ही डॉ. विनीता की टीम मदद के लिए तैयार है।",
    items: [
      { q: "डॉ. विनीता केसरी डेंटल क्लिनिक कहाँ स्थित है?", a: "हम DSS 379, सेक्टर 16-17, हिसार, हरियाणा में हैं — पहुँचना आसान और पास में पार्किंग। इस पेज पर \"रास्ता देखें\" बटन का उपयोग करें।" },
      { q: "क्लिनिक का समय क्या है?", a: "हम सोमवार से शनिवार, सुबह 10:00 से शाम 7:00 तक खुले रहते हैं। इमरजेंसी के लिए हम 24×7 उपलब्ध हैं — 9729002444 पर कॉल या WhatsApp करें।" },
      { q: "क्या आप रात या रविवार को डेंटल इमरजेंसी संभालते हैं?", a: "हाँ। तेज़ दाँत दर्द, सूजन, खून या चोट जैसी आपात स्थिति में आप 9729002444 पर किसी भी समय, नियमित समय के बाहर भी संपर्क कर सकते हैं।" },
      { q: "मैं अपॉइंटमेंट कैसे बुक करूँ?", a: "सबसे आसान तरीका — इस पेज पर कोई भी \"अपॉइंटमेंट बुक करें\" बटन दबाएं, यह आपके विवरण के साथ WhatsApp खोल देगा। आप सीधे कॉल भी कर सकते हैं।" },
      { q: "क्या डॉ. विनीता विशेषज्ञ हैं?", a: "हाँ। डॉ. विनीता जैन एक MDS पेरियोडॉन्टिस्ट व इम्प्लांटोलॉजिस्ट (मसूड़ा व डेंटल इम्प्लांट विशेषज्ञ) हैं, 15 वर्षों के अनुभव के साथ, साथ ही सभी जनरल डेंटल देखभाल भी।" },
      { q: "क्या इलाज में दर्द होता है? मुझे डेंटिस्ट से डर लगता है।", a: "अधिकांश मरीज़ यह देखकर हैरान होते हैं कि आधुनिक इलाज कितना दर्दरहित है। हम उन्नत माइक्रोस्कोपिक तकनीक का उपयोग करते हैं और घबराए या पहली बार आने वाले मरीज़ों का विशेष ध्यान रखते हैं।" },
      { q: "क्या आप मसूड़ों से खून व पायरिया जैसी समस्याओं का इलाज करते हैं?", a: "बिल्कुल — यही हमारी मुख्य विशेषज्ञता है। हम मसूड़ों से खून, संक्रमण, पायरिया का इलाज करते हैं और फ्लैप सर्जरी, बोन ग्राफ्टिंग जैसी उन्नत प्रक्रियाएँ प्रदान करते हैं।" },
      { q: "पहली विज़िट से पहले मुझे क्या करना चाहिए?", a: "कुछ ख़ास नहीं — बस पिछली डेंटल रिपोर्ट या एक्स-रे हों तो साथ लाएं। इलाज शुरू करने से पहले हम जाँच करेंगे और विकल्प स्पष्ट रूप से समझाएंगे।" },
      { q: "क्या आप दाँत सफ़ेद करना व स्माइल मेकओवर करते हैं?", a: "हाँ, हम दाँत सफ़ेद करना, विनियर और संपूर्ण एस्थेटिक स्माइल डिज़ाइनिंग प्रदान करते हैं ताकि आपको चमकदार, आत्मविश्वासी मुस्कान मिले।" },
      { q: "क्या उपकरण स्टेरलाइज़्ड व सुरक्षित हैं?", a: "हाँ, हम विश्वस्तरीय उपकरणों के साथ सख़्त स्टेराइल हाइजीन प्रोटोकॉल का पालन करते हैं, ताकि हर विज़िट पर हर मरीज़ का इलाज पूरी तरह सैनिटाइज़ उपकरणों से हो।" },
      { q: "क्या आप बच्चों व बुज़ुर्गों सहित हर उम्र के मरीज़ों का इलाज करते हैं?", a: "हाँ — बच्चे के पहले चेक-अप से लेकर बुज़ुर्ग मरीज़ों के सौम्य, दर्दरहित इलाज तक — हम हर उम्र के लिए संपूर्ण, मरीज़-केंद्रित डेंटल केयर प्रदान करते हैं।" },
      { q: "हिसार में डेंटल इम्प्लांट की कीमत कितनी है?", a: "डेंटल इम्प्लांट की कीमत इम्प्लांट सिस्टम, हड्डी की स्थिति और कितने दाँत बदलने हैं — इस पर निर्भर करती है। पहले फ्री कंसल्टेशन व एक्स-रे के बाद डॉ. विनीता आपको स्पष्ट, अग्रिम अनुमान देंगी — कोई छिपे शुल्क नहीं। वर्तमान कीमत जानने के लिए 9729002444 पर WhatsApp करें।" },
    ],
  },
  contact: {
    eyebrow: "08 / अभी बुक करें",
    heading: "अपनी अपॉइंटमेंट बुक करें",
    intro: "कुछ विवरण भरें और हम आपके अनुरोध के साथ WhatsApp खोल देंगे। बात करना पसंद करते हैं? सीधे कॉल करें — हम मदद के लिए तैयार हैं।",
    callLabel: "कॉल / WhatsApp",
    visitLabel: "हमसे मिलें",
    name: "नाम",
    namePh: "आपका पूरा नाम",
    phone: "फ़ोन",
    phonePh: "आपका मोबाइल नंबर",
    service: "आवश्यक सेवा",
    servicePh: "इलाज चुनें",
    date: "पसंदीदा तारीख़",
    datePh: "तारीख़ चुनें",
    time: "पसंदीदा समय",
    timePh: "समय चुनें",
    message: "संदेश (वैकल्पिक)",
    messagePh: "अपनी डेंटल समस्या संक्षेप में बताएं…",
    submit: "WhatsApp पर बुकिंग भेजें",
    note: "यह आपके विवरण के साथ WhatsApp खोलता है — कोई डेटा संग्रहित नहीं होता।",
    validation: "कृपया अपना नाम और फ़ोन नंबर जोड़ें ताकि हम आपका समय पक्का कर सकें।",
    opening: "आपके अपॉइंटमेंट विवरण के साथ WhatsApp खुल रहा है…",
  },
  footer: {
    tagline: "मरीज़-केंद्रित, सौम्य और दर्दरहित डेंटल केयर — डेंटल इम्प्लांट, विशेष मसूड़ा देखभाल, दाँत सफ़ेद करना, माइक्रोस्कोपिक डेंटिस्ट्री और एस्थेटिक स्माइल डिज़ाइनिंग — एक स्वस्थ, आत्मविश्वासी मुस्कान के लिए।",
    quickLinks: "त्वरित लिंक",
    visitHours: "पता / समय",
    hoursLine: "सोम – शनि: सुबह 10:00 – शाम 7:00",
    emergencyLine: "इमरजेंसी: 24×7",
    rights: "सर्वाधिकार सुरक्षित।",
    seoLine: "हिसार के सर्वश्रेष्ठ डेंटिस्ट · डेंटल इम्प्लांट · मसूड़ा देखभाल · स्माइल डिज़ाइनिंग",
  },
};

export const translations = { en, hi };

const TIME_KEYS = ["10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM", "06:00 PM"];
export const TIME_SLOTS = {
  en: TIME_KEYS,
  hi: ["सुबह 10:00", "सुबह 11:00", "दोपहर 12:00", "दोपहर 01:00", "दोपहर 02:00", "दोपहर 03:00", "शाम 04:00", "शाम 05:00", "शाम 06:00"],
};
